module.exports = __webpack_public_path__ + "img/BlinkArt_Wand_Epic.166cd9d8.png";